import { Component, OnInit, OnDestroy, Input, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UsersService } from './../../shared/services/users.service';
import { AuthService } from './../../shared/auth/auth.service';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { EventService } from '../../shared/services/event.service';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { RegistryService } from '../../shared/services/registry.service';
import { TicketService } from '../../shared/services/ticket.service';
import swal from 'sweetalert2';
import { WizardComponent } from 'angular-archwizard';
import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import * as firebase from 'firebase';
import { FormData } from 'app/pages/full-layout-page/add-events/data/formData.model';
import { TouchSequence } from 'selenium-webdriver';
// import { totalmem } from 'os';

@Component({
  selector: 'app-registry',
  templateUrl: './registry.component.html',
  styleUrls: ['./registry.component.scss']
})
export class RegistryComponent implements OnInit, OnDestroy {
  @Input()
  data: any;
  @Input()
  editMode: boolean;
  fetching: { [key: string]: any } = {};
  eventId: string;
  registryId: string;
  event: any;
  user: any;
  form: FormGroup;
  formPerson: FormGroup;
  formRegis: FormGroup;
  lg: string;
  ticketAmont = 1;
  ticketType: number;
  orderAmount = 1;
  orderType: number;
  registryConfirmBT = false;
  loading = false;
  @ViewChild(WizardComponent)
  public wizard: WizardComponent;
  uploader: FileUploader = new FileUploader({
    url: '',
    allowedMimeType: [
      'image/png',
      'image/jpg',
      'image/jpeg',
      'image/gif',
      'image/bmp',
      'image/webp',
      'image/x-icon',
      'image/vnd.microsoft.icon',
      'image/heif',
      'image/heic'
    ]
  });
  defaultStepIndex = 0;
  imgH;
  orderName;
  orderList;
  totalPrice = 0;
  orderId: string;
  shippingCharges = 0;
  orderSize: any;
  totalAmount = 0;
  isShipping = true;
  shippingAddress = {
    address: '',
    province: '',
    zipCode: ''
  };
  isAgreement = true;
  constructor(
    private activatedRoute: ActivatedRoute,
    private usersService: UsersService,
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private eventService: EventService,
    private translateService: TranslateService,
    private registryService: RegistryService,
    private router: Router,
    private ticketService: TicketService
  ) {
    this.form = this.initFormGroup();
    // this.formPerson = this.initRegisUsersGroup();
    this.formRegis = this.initRegisGroup();
    this.lg = this.translateService.currentLang;
    this.fetching['lg'] = this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.lg = event.lang;
    });
  }

  ngOnInit() {
    if (this.data && this.editMode) {
      this.wizard.navigation.goToStep(3);
    } else {
      this.fetching['getEventId'] = this.activatedRoute.params.subscribe(params => {
        this.eventId = params['eventId'];
        this.registryId = params['id'];
        const admin = params['admin'];
        const userId = params['userId'];
        // console.log(params);
        this.eventService
          .getOneById(this.eventId)
          .then(res => {
            this.event = res.data();
            // console.log(this.event);
            this.imgH = this.event.eventTypes.types[0].img;
            this.orderType = this.event.eventTypes.types[0].price;
            this.orderName = this.event.eventTypes.types[0].name;
            this.orderId = this.event.eventTypes.types[0].id;
            if (this.event.eventTypes.shirts.length) {
              this.orderSize = this.event.eventTypes.shirts[0];
              // console.log(this.orderSize);
            }
            if (this.event.hasOwnProperty('delivery')) {
              if (this.event.delivery.hasOwnProperty('shippingCharges')) {
                this.shippingCharges = this.event.delivery.shippingCharges;
              }
            }
            this.setId();
          })
          .catch(err => {
            console.log(err);
          });

        if (this.registryId) {
          this.subscribeData(this.registryId);
          // document.getElementById('gotoPayment').click();
        }

        if (admin) {
          this.usersService
            .getOne(this.authService.authState.uid)
            .then(res => {
              // console.log(res.data());
              this.usersService
                .getOne(userId)
                .then(userRes => {
                  this.user = userRes.data();
                  if (this.user.hasOwnProperty('address')) {
                    this.shippingAddress.address = this.user.address;
                  }
                  if (this.user.hasOwnProperty('province')) {
                    this.shippingAddress.province = this.user.province;
                  }
                  if (this.user.hasOwnProperty('zipCode')) {
                    this.shippingAddress.zipCode = this.user.zipCode;
                  }
                  this.form.get('user').setValue(userRes.data());
                })
                .catch(err => {
                  console.log(err);
                });
            })
            .catch(err => {
              console.log(err);
            });
        } else {
          this.usersService
            .getOne(this.authService.authUserState.uid)
            .then(res => {
              // console.log(res.data());
              this.user = res.data();
              if (this.user.hasOwnProperty('address')) {
                this.shippingAddress.address = this.user.address;
              }
              if (this.user.hasOwnProperty('province')) {
                this.shippingAddress.province = this.user.province;
              }
              if (this.user.hasOwnProperty('zipCode')) {
                this.shippingAddress.zipCode = this.user.zipCode;
              }
              this.form.get('user').setValue(res.data());
            })
            .catch(err => {
              console.log(err);
            });
        }
      });
    }
  }

  subscribeData(id) {
    this.fetching['getRegistryData'] = this.registryService.getById(id).subscribe((res: any) => {
      if (res.id) {
        this.data = res;
        if (this.data.data.isShipping) {
          this.shippingAddress = this.data.data.shippingAddress;
        }
        this.defaultStepIndex = 2;
        this.wizard.navigation.goToStep(2);
      }
    });
  }

  setId() {
    if (this.event.eventId) {
      this.form.get('eventId').setValue(this.event.eventId);
    }
  }

  get disableBT() {
    if (this.data) {
      return true;
    }
    return false;
  }

  get disableBTStep1() {
    if (
      this.isAgreement &&
      this.event &&
      this.user &&
      this.user.dateOfBirth &&
      this.user.displayName &&
      this.user.mobileNumber
    ) {
      return false;
    }
    return true;
  }

  ngOnDestroy() {
    for (const key in this.fetching) {
      if (this.fetching.hasOwnProperty(key) && this.fetching[key]) {
        this.fetching[key].unsubscribe();
      }
    }
  }

  updateUser() {
    this.loading = true;
    this.usersService
      .update(this.user.id, this.user)
      .then(res => {
        // console.log(res);
        if (this.user.hasOwnProperty('address')) {
          this.shippingAddress.address = this.user.address;
        }
        if (this.user.hasOwnProperty('province')) {
          this.shippingAddress.province = this.user.province;
        }
        if (this.user.hasOwnProperty('zipCode')) {
          this.shippingAddress.zipCode = this.user.zipCode;
        }
        if (this.formRegis.controls.regisList.value.length === 0) {
          this.addRegisList();
        }
        this.loading = false;
      })
      .catch(err => {
        console.log(err);
        this.loading = false;
      });
  }

  addItem(typeId, amount, price, size?) {
    if (typeof this.orderList === 'undefined') {
      this.orderList = [];
    }

    const order = [...this.orderList].find(
      t => t.typeId === typeId && t.size.size === size.size && t.size.mainType === size.mainType
    );
    if (order) {
      order.amount += Number(amount);
      order.totalPrice += Number(amount) * Number(price);
      order.totalAmount += Number(amount);
    } else {
      this.orderList.push({
        typeId: typeId,
        amount: Number(amount),
        price: Number(price),
        size: size || '-',
        totalPrice: Number(amount) * Number(price),
        totalAmount: Number(amount)
      });
      // console.log('add');
    }
    this.totalPrice += Number(amount) * Number(price);
    this.totalAmount += Number(amount);
  }

  getDetailType(typeId) {
    const tmpTypes = [...this.event.eventTypes.types];
    const type = tmpTypes.find(t => t.id === typeId);
    // console.log(type);
    return type;
  }

  // get optionData(){
  //   return{
  //     shirts : this.event.
  //   }
  // }

  removeItem(index, totalPrice, totalAmount) {
    this.orderList.splice(index, 1);
    this.totalPrice -= Number(totalPrice);
    this.totalAmount -= Number(totalAmount);
  }

  initFormGroup(): FormGroup {
    const formControls = {
      id: null,
      eventId: [null, Validators.required],
      payment: null,
      user: null,
      event: null,
      isActive: true,
      isDeleted: false
    };
    return this.formBuilder.group(formControls);
  }

  preConfirm() {
    // this.loading = true;
    let tmpTotalAmount = 0;
    let tmpTotalPrice = 0;
    this.formRegis.value.regisList.forEach(element => {
      tmpTotalAmount++;
      tmpTotalPrice += element.entry.price;
    });
    this.formRegis.controls.totalAmount.setValue(tmpTotalAmount);
    this.formRegis.controls.totalPrice.setValue(tmpTotalPrice);
    this.formRegis.controls.totalNet.setValue(tmpTotalPrice);
    // this.loading = false;
  }

  // regisList
  get regisListFormArray(): FormArray {
    return this.formRegis.get('regisList') as FormArray;
  }
  addRegisList() {
    const controls = <FormArray>this.formRegis.controls['regisList'];
    controls.push(this.initRegisUsersGroup());
  }

  removeRegisList(index: number) {
    const controls = <FormArray>this.formRegis.controls['regisList'];
    controls.removeAt(index);
  }

  setRegisUsersFormArray(form: FormGroup, data) {
    const formGroups = data.map(item => {
      const fg = this.initRegisUsersGroup();
      fg.patchValue(item);
      return fg;
    });

    const formArray = this.formBuilder.array(formGroups);
    form.setControl('regisList', formArray);
  }

  initRegisGroup(): FormGroup {
    const formControls = {
      regisList: this.formBuilder.array([]),
      totalPrice: null,
      totalAmount: null,
      totalNet: null
    };
    return this.formBuilder.group(formControls);
  }

  initRegisUsersGroup(): FormGroup {
    const formControls = {
      name: [null, Validators.required],
      dateOfBirth: [null, Validators.required],
      age: [0, Validators.required],
      gender: [null, Validators.required],
      bloodType: [null, Validators.required],
      mobileNumber: [null, Validators.required],
      idCard: null,
      passportNumber: null,
      nationality: null,
      email: null,
      lineId: null,
      team: null,
      emrContactName: null,
      emrContactPhoneNumber: null,
      emrContactAddress: null,
      ageType: [null, Validators.required],
      ageTypeId: [null, Validators.required],
      entry: [null, Validators.required],
      shirtSize: [null, Validators.required],
      isMe: null
    };
    return this.formBuilder.group(formControls);
  }

  getFormRegis() {
    console.log(this.formRegis.value);
  }

  confirmRegistry() {
    this.registryConfirmBT = true;
    const tmpEventDetails = { ...this.event.eventDetails };
    delete tmpEventDetails.details;
    delete tmpEventDetails.agreement;
    delete tmpEventDetails.agreement_en;
    const data = {
      id: null,
      event: {
        eventId: this.eventId,
        eventRef: this.form.value.eventId,
        details: tmpEventDetails,
        type: this.event.type
      },
      user: {
        displayName: this.user.displayName,
        mobileNumber: this.user.mobileNumber || '-',
        userId: this.user.id,
        email: this.user.email
      },
      data: this.formRegis.value,
      payment: {
        paymentAmount: null,
        remark: null,
        fees: null,
        pay: false,
        type: null,
        dataLog: null,
        imgConfirm: [],
        checkingPayment: false,
        updateAt: this.registryService.getTimestamp()
      },
      isActive: true,
      isDeleted: false
    };

    this.registryService
      .add(data)
      .then(res => {
        // console.log(res);
        this.registryService
          .updateIdOrder(res.id)
          .then(resUpdate => {
            // console.log(resUpdate);
            data.id = res.id;
            this.subscribeData(res.id);
            // this.data = { ...data };
            // console.log(this.data);
            // this.sentMail(data.id, data.user.displayName);
            swal({
              type: 'success',
              title: 'Success',
              showConfirmButton: false,
              timer: 1000
            });
          })
          .catch(err => {
            console.log(err);
            this.registryConfirmBT = false;
          });
      })
      .catch(err => {
        console.log(err);
        this.registryConfirmBT = false;
      });
  }

  onUploadSinger() {
    this.loading = true;
    // console.log(this.uploader.queue);
    if (this.uploader.queue.length) {
      const storageRef = firebase.storage().ref();
      const uploadTask = storageRef
        .child(
          `imgs/slipspayment/${this.user.id}/registry/${this.data.id}/${Date.now()}${
            this.uploader.queue[this.uploader.queue.length - 1]['_file'].name
          }`
        )
        .put(this.uploader.queue[this.uploader.queue.length - 1]['_file']);

      uploadTask.on(
        firebase.storage.TaskEvent.STATE_CHANGED,
        (snapshot: any) => {
          // upload in progress
          this.uploader.progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          // console.log(this.uploader.progress);
          // console.log(snapshot);
        },
        error => {
          // upload failed
          console.log(error);
          this.loading = false;
        },
        () => {
          // upload success
          uploadTask.snapshot.ref
            .getDownloadURL()
            .then(downloadURL => {
              // console.log(downloadURL);
              if (downloadURL) {
                if (typeof this.data.payment.imgConfirm === 'undefined') {
                  this.data.payment.imgConfirm = [];
                }
                this.data.payment.imgConfirm.push(downloadURL);
                this.data.payment.type = 'transfer';
                this.data.payment.checkingPayment = true;
                this.data.payment.updateAt = firebase.firestore.FieldValue.serverTimestamp();
                this.registryService
                  .updateOrder(this.data.id, { payment: this.data.payment })
                  .then(res => {
                    let tmpText: string;
                    if (this.lg === 'th') {
                      tmpText = `ระบบได้รับแจ้งการซำระเงินของท่านแล้ว! โปรดรอการตรวจสอบ ใช้เวลาอย่างน้อย 1 วัน เมื่อสำเร็จระบบจะส่งอีเมลไปยืนยันท่าน หรือ สามารถตรวจสถานะได้ด้วยตัวเองที่เมนู "อีเวนต์ของฉัน"`;
                    } else {
                      tmpText = `We has been notified of your payment! Please wait. At least 1 day to complete, the system will send an email to confirm you, or you can check yourself at the menu. "My Events"`;
                    }
                    swal({
                      type: 'success',
                      title: 'Upload Success',
                      text: tmpText
                      // showConfirmButton: false,
                      // timer: 1000
                    });
                    this.loading = false;
                    this.uploader.clearQueue();
                  })
                  .catch(err => {
                    this.loading = false;
                    console.log(err);
                    swal({
                      type: 'error',
                      title: 'Error',
                      showConfirmButton: false,
                      timer: 2000
                    });
                  });
              }
            })
            .catch(err => {
              this.loading = false;
              console.log(err);
              swal({
                type: 'error',
                title: 'Error',
                showConfirmButton: false,
                timer: 2000
              });
            });
        }
      );
    } else {
      this.loading = false;
      swal({
        type: 'error',
        title: 'File not supported.'
        // showConfirmButton: false,
        // timer: 2000
      });
    }
  }

  goTo(ticketId) {
    this.router.navigate(
      [
        'user/ticket',
        {
          ticketId: ticketId
        }
      ],
      { skipLocationChange: true }
    );
  }

  goToMyEvent() {
    this.router.navigate(
      [
        'user',
        {
          page: 'myEvents',
          id: this.user.id
        }
      ]
      // { skipLocationChange: true }
    );
  }

  sentMail(registryId, cusName) {
    const datato = {
      from: 'dev@phuketsoftware.net',
      subject: 'Registry',
      html: `<p>Dear, admin </p>
         <p>คุณ ${cusName} ได้สั่งชื้อ<p>
         <h3>RegistryId : ${registryId} </h3>
         <br>
         <div style="color: rgba(0,0,0,0.4); text-align: center; font-size: 13px;" >
         <p>Phuketsoftgroup Co.,Ltd. 65/131 Phuket Villa Suanluang, Vichit, Phuket 83000</p>
         <p> Email : info@phuketsoftgroup.net   LINE : @phuketsoftware.net </p>
         <p>www.phuketsoftevents.com </p>
         </div>
        `,
      // to: 'info@phuketsoftware.net'
      to: 'dev@phuketsoftware.net'
    };
    this.ticketService.sentmail(datato).subscribe(
      res => {
        console.log(res);
      },
      err => {
        console.log(err);
      }
    );
  }
}
